import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import { InstallPrompt } from './components/InstallPrompt';
import { LoginScreen } from './screens/LoginScreen';
import { DashboardScreen } from './screens/DashboardScreen';
import { UploadImagesScreen } from './screens/UploadImagesScreen';
import { ProductPreviewScreen } from './screens/ProductPreviewScreen';
import { MyProductsScreen } from './screens/MyProductsScreen';
import { MarketingScreen } from './screens/MarketingScreen';
import { ExportSuccessScreen } from './screens/ExportSuccessScreen';
import { PlatformGuideScreen } from './screens/PlatformGuideScreen';
import { ShopifyConnectionScreen } from './screens/ShopifyConnectionScreen';
import { BrandBrainScreen } from './screens/BrandBrainScreen';
import { ContentStudioScreen } from './screens/ContentStudioScreen';
import { VisualCommerceScreen } from './screens/VisualCommerceScreen';
import { VideoCommerceScreen } from './screens/VideoCommerceScreen';
import { VideoLibraryScreen } from './screens/VideoLibraryScreen';
import { VideoStudioScreen } from './screens/VideoStudioScreen';
import { ProductEditScreen } from './screens/ProductEditScreen';
import { GrowthDashboardScreen } from './screens/GrowthDashboardScreen';
import { BusinessProfileScreen } from './screens/BusinessProfileScreen';
import { MoreScreen } from './screens/MoreScreen';
import { LocalSEOScreen } from './screens/LocalSEOScreen';
import { ReputationScreen } from './screens/ReputationScreen';
import { PrivacyPolicyScreen } from './screens/PrivacyPolicyScreen';
import { DeleteAccountScreen } from './screens/DeleteAccountScreen';
import '@/App.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#F0F2F5] flex items-center justify-center"><p>Loading...</p></div>;
  return user ? children : <Navigate to="/login" />;
};

const P = ({ children }) => <PrivateRoute>{children}</PrivateRoute>;

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <Routes>
              <Route path="/login" element={<LoginScreen />} />
              {/* Main Nav */}
              <Route path="/home" element={<P><DashboardScreen /></P>} />
              <Route path="/my-products" element={<P><MyProductsScreen /></P>} />
              <Route path="/growth" element={<P><GrowthDashboardScreen /></P>} />
              <Route path="/more" element={<P><MoreScreen /></P>} />
              {/* Product */}
              <Route path="/upload" element={<P><UploadImagesScreen /></P>} />
              <Route path="/product/:productId" element={<P><ProductPreviewScreen /></P>} />
              <Route path="/content-studio/:productId" element={<P><ContentStudioScreen /></P>} />
              <Route path="/visual-commerce/:productId" element={<P><VisualCommerceScreen /></P>} />
              <Route path="/video-studio/:productId" element={<P><VideoCommerceScreen /></P>} />
              <Route path="/video-engine/:productId" element={<P><VideoStudioScreen /></P>} />
              <Route path="/video-library" element={<P><VideoLibraryScreen /></P>} />
              <Route path="/product-edit/:productId" element={<P><ProductEditScreen /></P>} />
              <Route path="/marketing/:productId" element={<P><MarketingScreen /></P>} />
              {/* Brand & Business */}
              <Route path="/brand-brain" element={<P><BrandBrainScreen /></P>} />
              <Route path="/more/business-profile" element={<P><BusinessProfileScreen /></P>} />
              <Route path="/more/business-profile/new" element={<P><BusinessProfileScreen /></P>} />
              <Route path="/more/local-seo" element={<P><LocalSEOScreen /></P>} />
              <Route path="/more/reputation" element={<P><ReputationScreen /></P>} />
              <Route path="/more/locations" element={<P><BusinessProfileScreen /></P>} />
              {/* Export */}
              <Route path="/export-success" element={<P><ExportSuccessScreen /></P>} />
              <Route path="/platform-guide" element={<P><PlatformGuideScreen /></P>} />
              <Route path="/shopify-connect" element={<P><ShopifyConnectionScreen /></P>} />
              {/* Public */}
              <Route path="/privacy-policy" element={<PrivacyPolicyScreen />} />
              <Route path="/delete-account" element={<DeleteAccountScreen />} />
              <Route path="/" element={<Navigate to="/login" />} />
              <Route path="*" element={<Navigate to="/home" />} />
            </Routes>
            <Toaster position="top-center" toastOptions={{ style: { background: '#fff', color: '#111B21', border: '1px solid #E5E7EB' } }} />
            <InstallPrompt />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
